import script from "./ExperienceItemEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceItemEditor.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceItemEditor.vue?vue&type=style&index=0&id=0bf29bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf29bb4"]])

export default __exports__